import React, { useState } from "react";
import ClassNames from "classnames";
import * as s from "./s.module.scss"

const TextField = ({ className, placeholder, type, fileInputValue, ...props }) => {
  const [value, setValue] = useState("");
  switch (type) {
    case "text":
      return (
        <input
          placeholder={placeholder}
          className={ClassNames(s.input, className)}
          type="text"
          value={value}
          onChange={e => setValue(e.target.value)}
          {...props}
        />
      );
    case "textarea":
      return (
        <textarea
          placeholder={placeholder}
          className={ClassNames(s.input, className)}
          value={value}
          onChange={e => setValue(e.target.value)}
          {...props}
        />
      );
    case "file":
      return (
        <div className={s.inputFileWrapper}>
          <span
            className={ClassNames(s.fileName, {
              [s.fileSelected]: fileInputValue
            })}
          >
            {fileInputValue ? fileInputValue.name : placeholder}
          </span>
          <input
            className={ClassNames(s.input, className)}
            type={type}
            //onChange={e => setValue(e.target.value)}
            {...props}
          />
        </div>
      );
    default:
      return (
        <input
          placeholder={placeholder}
          className={ClassNames(s.input, className)}
          type={type || "text"}
          value={value}
          onChange={e => {
            setValue(e.target.value);
          }}
          {...props}
        />
      );
  }
};

export default TextField;
